module.exports = __webpack_public_path__ + "static/media/bagel_with_money.7808b6e1.svg";